import { Service } from '../../../model/professional/service-model';

// Données mockées pour les services pendant l'onboarding
export const mockServices: Service[] = [
  {
    id: 'mock-service-1',
    name: 'Coupe Femme',
    description: 'Coupe de cheveux pour femme avec brushing',
    duration: 90,
    price: 65,
    companyId: 'mock-company-id',
    requiresBooking: true,
    isActive: true,
    image: '/mock-img/coupe-femme.webp',
    imageVariants: {
      original: '/mock-img/coupe-femme.webp',
      medium: '/mock-img/coupe-femme-medium.webp',
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'mock-service-2',
    name: 'Coupe Homme',
    description: 'Coupe de cheveux pour homme avec finition et coiffage',
    duration: 120,
    price: 85,
    companyId: 'mock-company-id',
    requiresBooking: false,
    isActive: true,
    image: '/mock-img/coupe-homme.webp',
    imageVariants: {
      original: '/mock-img/coupe-homme.webp',
      medium: '/mock-img/coupe-homme-medium.webp',
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'mock-service-3',
    name: 'Soin du visage',
    description: 'Soin complet du visage avec massage',
    duration: 40,
    price: 35,
    companyId: 'mock-company-id',
    requiresBooking: false,
    isActive: false,
    image: '/mock-img/soin-visage.webp',
    imageVariants: {
      original: '/mock-img/soin-visage.webp',
      medium: '/mock-img/soin-visage-medium.webp',
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  }
];

// Fonction pour filtrer les services mockés
export const getFilteredServices = (searchTerm: string = '', statusFilter: string = 'all'): Service[] => {
  return mockServices.filter(service => {
    // Filtre par terme de recherche
    const matchesSearch = searchTerm === '' || 
      service.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
      (service.description?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false);
    
    // Filtre par statut
    const matchesStatus = 
      statusFilter === 'all' || 
      (statusFilter === 'active' && service.isActive) || 
      (statusFilter === 'inactive' && !service.isActive);
    
    return matchesSearch && matchesStatus;
  });
};
